import { BaseIcon } from './base-icon.js';
import { svg } from 'lit';

/**
 * Download Icon Component
 * Document with download arrow (outline style)
 * Used for download buttons (invoices, documents)
 */
class DownloadIcon extends BaseIcon {
    getSvgAttributes() {
        return {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 24 24',
            fill: 'none',
            stroke: 'currentColor',
            'stroke-width': '2',
        };
    }

    renderIconPath() {
        return svg`
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
        `;
    }
}

customElements.define('download-icon', DownloadIcon);
